import type { BuilderContent } from '@builder.io/sdk-vue/lib/browser/types/builder-content'
import type { MergeHead, UseHeadInput } from '@unhead/vue'

export const toBookHeadSeoFactory = (suffix = 'Miljn', separator = ' – ') => {
  return (content: BuilderContent) => toBookHeadSeo(content, suffix, separator)
}

export const toBookHeadSeo = (
  content: BuilderContent,
  suffix = 'Miljn',
  separator = ' – ',
): UseHeadInput<MergeHead> => {
  const meta: {
    name: string
    content: string
  }[] = []

  if (content?.data?.seo?.description) {
    meta.push({
      name: 'description',
      content: content?.data?.seo?.description,
    })
  }

  return {
    title: [content?.data?.seo?.description, suffix]
      .filter((item) => item)
      .join(separator),
    meta,
  }
}
